import React, { useState, useEffect } from "react";
import style from "./style.module.css";
import styleVue2 from "../../style..module.css";
import LoadContent from "../../../../components/LoadContent";
import ProductsWithSlide from "../../../../components/ProductsWithSlide";
import DetailsBigBanner from "../../components/DetailsBigBanner";
import DescriptionTitle from "../../components/DescriptionTitle";
import DetailsCategories from "../../components/DetailsCategories";
import BanerSlider from "../../../../components/BanerSlider";
import { useDispatch, useSelector } from "react-redux";
import FromToPage from "../../../../components/FromToPage";
import langData from "../../../../lang/data";
import styles from "../../../../components/BanerSlider/style.module.css";
import stylesProductList from "../../../../screens/Category/styles.module.css";
import ProductList from "screens/Category/components/productList/newIndex";
import { useSearchParams,useNavigate } from "react-router-dom";
import { selectCategory } from "store/selector";
import Attributes from "screens/Category/components/Attribute/newIndex";
import { searchWsPageMan } from "store/WsSearchSlice";

const DetailsVue4 = ({ detailsList, isLoading, error, currentLanguage }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [load, setLoad] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [recordPage, setRecordPage] = useState(20);
  const { loading } = useSelector(selectCategory);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { filters } = useSelector(
    ({ WsSearchSlice }) => WsSearchSlice
  );
  useEffect(() => {
    const paramsArray = Array.from(searchParams.entries());
    const filteredParamsArray = paramsArray.filter(
      ([_, value]) => value !== null && value !== ""
    );

    const filteredInfo = Object.fromEntries(filteredParamsArray);

    dispatch(searchWsPageMan( detailsList?.sale?.id, filteredInfo, navigate, detailsList?.sale?.id,'sale'));
  }, [detailsList?.sale?.id, dispatch, navigate, searchParams]);

  const handleMoreProducts = () => {
    setLoad(true);
    setCurrentPage(1);
    searchParams.set("p", +filters?.products?.length + recordPage);
    setSearchParams(searchParams);
  };

  return (
    <div className="wrapper">
      <FromToPage
        pages={[
          {
            label: langData.titles.Offers[currentLanguage],
            value: "",
            active: false,
          },
          {
            label: detailsList?.sale?.["name_" + currentLanguage],
            value: "",
            active: true,
          },
        ]}
      />
      <DetailsBigBanner
        isLoading={isLoading}
        currentLanguage={currentLanguage}
        detailsList={detailsList}
      />
      <div className={styleVue2.details_description}>
        {!isLoading && detailsList.sale ? (
          <>
            <p
              dangerouslySetInnerHTML={{
                __html: detailsList.sale?.["description_" + currentLanguage],
              }}
            />
          </>
        ) : (
          <>
            {Array.from({ length: 3 }).map((_, index) => {
              return (
                <div className={styleVue2.details_description_loader_item}>
                  <LoadContent
                    key={index}
                    containerClassName={styleVue2.details_description_loader}
                  />
                </div>
              );
            })}
          </>
        )}
      </div>
      <div className={style.details_vue1_categories}>
        {!isLoading ? (
          detailsList.categories ? (
            <DetailsCategories
              list={detailsList.categories}
              detailsList={detailsList}
            />
          ) : null
        ) : (
          <div className={style.details_loader_categories}>
            {Array.from({ length: 5 }).map((_, index) => (
              <LoadContent
                key={index}
                containerClassName={style.details_loader_categories_item}
              />
            ))}
          </div>
        )}
      </div>
      {!isLoading && detailsList?.sale ? (
        <DescriptionTitle
          currentLanguage={currentLanguage}
          detailsList={detailsList}
        />
      ) : null}
      {detailsList?.products_first_slider?.length ? (
        <div className={style.details_vue1_slider}>
          <ProductsWithSlide
            productsData={detailsList?.products_first_slider}
            noWrapper={true}
          />
        </div>
      ):null}
      {!isLoading ? (
        <div className={style.details_banner_slider}>
          <BanerSlider
            bannerSliders={detailsList.sliders}
            currentLanguage={currentLanguage}
          />
        </div>
      ) : (
        <LoadContent containerClassName={styles.loadContent} />
      )}
       <Attributes
          styles={stylesProductList}
          setCurrentPage={setCurrentPage}
          filters={filters}
          loading={isLoading}
          currentLanguage = {currentLanguage}
        />
      {!isLoading && filters?.products?.length ? (
        <div style={{ marginTop: 60 }}>
          <ProductList
            load={load}
            styles={stylesProductList}
            handlePagination={(e) => {
              searchParams.set("page", e);
              setSearchParams(searchParams);
              setCurrentPage(e);
            }}
            currentPage={currentPage}
            handleMoreProducts={handleMoreProducts}
            recordPage={recordPage}
            setRecordPage={setRecordPage}
            category={filters}
            loading={loading}
          />
        </div>
      ) : (
        <div style={{ marginTop: 60 }}>
          <LoadContent containerClassName={styles.loadContent} />
        </div>
      )}
      {/* <FilterProducts /> */}
      {/* detailsList?.products_first_slider */}
      {/* <SearchResult /> */}
    </div>
  );
};

export default DetailsVue4;
